import React from 'react';
import { MapPin, ArrowUpRight } from 'lucide-react';
import { useSite } from '@/context/SiteContext';
import { Reveal, SectionHeading } from './Motion';

export const LocationSection = ({ compact = false }) => {
  const { site } = useSite();
  const s = site?.settings || {};
  if (s.map_lat == null || s.map_lng == null) return null;
  const lat = Number(s.map_lat);
  const lng = Number(s.map_lng);
  const zoom = s.map_zoom || 15;
  const embed = `https://maps.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed&hl=en`;
  const gmaps = s.google_maps_url || `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

  return (
    <section className={compact ? 'py-10' : 'section-y'} data-testid="location-section">
      <div className="container-x grid grid-cols-1 md:grid-cols-12 gap-10 items-start">
        <div className="md:col-span-4">
          <SectionHeading label="Location" title={s.location_title || 'Find us'} body={s.location_body} />
          <Reveal delay={0.15} className="mt-8 space-y-3 text-sm text-foreground/75">
            {s.address && <p className="flex gap-2.5"><MapPin className="h-4 w-4 mt-0.5 text-[hsl(var(--brand-teal))] shrink-0" />{s.address}</p>}
            <a href={gmaps} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 eyebrow text-foreground link-underline" data-testid="location-open-maps-link">
              Open in Google Maps <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </Reveal>
        </div>
        <Reveal className="md:col-span-8" delay={0.1}>
          <div className="rounded-xl overflow-hidden border border-border bg-muted h-[360px] sm:h-[420px] md:h-[480px]" data-testid="location-map">
            <iframe
              title="Bukit Ancak Lembongan Resort location"
              src={embed}
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'saturate(0.85) contrast(1.02)' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
